import ConversionBannerFinance from '../components/banners/ConversionBannerFinance';

export default function getBanner(flowName) {
    switch (flowName) {
        case 'finance':
            return ConversionBannerFinance;
        case 'financial_lease':
            return ConversionBannerFinance;
        default:
            return null;
    }
}
